module.exports = __webpack_public_path__ + "images/virtual-labs.61c4cc81.webp";